// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1Ulhu","footer":"Form_footer__2z_GQ"};